module.exports = __webpack_public_path__ + "img/395.1596d6b4.jpg";